import { P } from '~components/Typography';
import { usePaywallContext } from '~context/paywall';
import { CheckoutReason } from '~features/annals';
import { useHasSubscription } from '~features/tags';
import { useCurrentBot } from '~hooks/useCurrentBot';
import { Loader } from '~shared/ui/atoms';
import { ButtonOutline } from '~shared/ui/molecules';

import { ButtonContent, LoaderWrapper, Wrapper } from './styles';

export const ChatImageGenerationLoader = ({
	recipientId,
}: {
	recipientId: string;
}) => {
	const {
		bot: { generations = [] },
	} = useCurrentBot({ recipientId });

	const [hasSubscription] = useHasSubscription();
	const { openPaywall } = usePaywallContext();

	return generations.length > 0 ? (
		<Wrapper>
			<LoaderWrapper pro={hasSubscription}>
				<Loader size={64} />
			</LoaderWrapper>
			<P size="small" weight={600}>
				Taking photo
			</P>
			<P size="xsmall">
				{hasSubscription
					? 'Wait for it...'
					: 'You are on free servers, please wait'}
			</P>
			{hasSubscription ? null : (
				<>
					<P weight={600} size="xsmall" transparent>
						or
					</P>
					<ButtonOutline
						text=""
						onClick={openPaywall({
							prefer: 'subscription',
							checkoutReason: CheckoutReason.ChatImageGeneration,
							botClientId: recipientId,
						})}
					>
						<ButtonContent>
							Become a <span>Pro</span> member
						</ButtonContent>
					</ButtonOutline>
				</>
			)}
		</Wrapper>
	) : null;
};
